import Button from "../../../utilities/Button";
import {useStores} from "../../../../stores/useStores";

function FollowingButton(props) {
    const {sidebarStore} = useStores();

    return (
        <Button onClick={() => {
            sidebarStore.setSidebar({
                view: "Following"
            })
        }} {...props}>{props.children}</Button>
    );
}

export default FollowingButton;
